module.exports = __webpack_public_path__ + "static/media/profile4.981ba241.jpg";